/* @ngInject */
function AssetCardController (
  $rootScope,
  $scope,
  $state,
  $timeout,
  $translate,
  $q,
  $location,
  RepositoryService,
  Utils,
  ToastService,
  NewAssetService,
  AssetService,
  UdsModalService,
  SegmentService,
  CampaignService
) {
  const getMoveToTrashDialogController = () =>
    $q.when(import('../../dialogs/move-to-trash/move-to-trash-dialog.controller'))
  const getOrganizeAssetDialogController = () =>
    $q.when(import('../../dialogs/organize-asset/organize-asset-dialog.controller'))
  const getManageAssetsDialogController = () =>
    $q.when(import('../../dialogs/manage-assets/manage-assets-dialog.controller'))
  const getUpgradeCompanyPlanDialogController = () =>
    $q.when(import('../../../core/dialogs/upgrade-company-plan/upgrade-company-plan-dialog.controller'))
  const getModulesPricingDialogController = () =>
    $q.when(import('../../../core/dialogs/modules-pricing/modules-pricing-dialog.controller'))
  const getRemoveAttachmentDialogController = () =>
    $q.when(import('../../../campaigns/dialogs/remove-attachment/remove-attachment-dialog.controller'))
  const getShareWithGuestsDialogController = () =>
    $q.when(import('../../../core/dialogs/share-with-guests/share-with-guests-dialog.controller'))
  const getChooseDocFormatToDownloadDialogController = () =>
    $q.when(import('../../dialogs/choose-doc-format-to-download/choose-doc-format-to-download-dialog.controller'))

  const api = {
    getUpgradeCompanyPlanDialogController,
    getModulesPricingDialogController,
    getMoveToTrashDialogController,
    getOrganizeAssetDialogController,
    getManageAssetsDialogController,
    getShareWithGuestsDialogController,
    getChooseDocFormatToDownloadDialogController,
    _openMoveToTrashDialog,
    _handleAssetData,
    _getAssetSize,
    _setAssetThumbnailSrc,
    _checkShowShareButton,
    _removeAssetFromList,
    _openPricingUpgradeDialog,
    _checkAssetHasThumbnail,
    _waitAssetThumbnail,
    _removeAttachmentFromCampaign,
    _handleShiftClickOnAsset,
    _unselectAllExceptFirstSelected,
    _openDocPreview,
    _setupKeyboardNavigation
  }

  this.getApi = () => api

  $scope.goBackRoute = ''

  activate()

  function activate () {
    const path = $location.path().replace(/^\//, '')
    $scope.goBackRoute = path
    $scope.isFirstAssetOfRow = $scope.assetIndex % 4 !== 0
    api._handleAssetData()
    api._checkShowShareButton()
    api._setupKeyboardNavigation()
  }

  function _handleAssetData () {
    api._setAssetThumbnailSrc()
    api._checkAssetHasThumbnail().then(hasThumbnail => {
      if (!hasThumbnail) {
        api._waitAssetThumbnail()
      }
    })

    $scope.assetIcon = RepositoryService.defineAssetIconBasedOnExtension($scope.asset)
    $scope.assetType = RepositoryService.defineAssetTypeBasedOnExtension($scope.asset)
    $scope.assetSize = api._getAssetSize($scope.asset)
  }

  function _checkAssetHasThumbnail () {
    return NewAssetService.checkAssetHasThumb($scope.asset.id, 'LOW')
  }

  function _waitAssetThumbnail () {
    NewAssetService.waitAssetThumbnail({
      assetId: $scope.asset.id,
      quality: 'LOW'
    }).then(() => {
      const forceRefresh = true
      api._setAssetThumbnailSrc(forceRefresh)
    })
  }

  function _setAssetThumbnailSrc (forceRefresh = false) {
    const { thumbnail, default: defaultThumb } = $scope.asset.src

    const url = thumbnail || defaultThumb

    if (!forceRefresh) {
      $scope.assetThumbnailSrc = url
      return
    }

    $scope.assetThumbnailSrc = Utils.fnAddQueryToUrl(url, { date: new Date().getTime() })
    $scope.$apply()
  }

  function _checkShowShareButton () {
    Promise.all([
      $rootScope.getCompanyFeaturesAndAddons(),
      $rootScope.getCompanyFeatures(),
      $rootScope.getUser()
    ]).then(([{ features }, companyFeatures, user]) => {
      $scope.showShareButton = (features['SHARE.GUEST'] || companyFeatures.includes('GUEST_ASSET_PACK')) && $rootScope.isUserSysAdminAdmin(user)
    })
  }

  const deregisterUpdateAssetName = $rootScope.$on(`asset-card-${$scope.asset.id}.update-asset-name`, (_, newName) => {
    $scope.asset.name = newName
    api._handleAssetData()
  })

  const deregisterUpdateAssetThumbnail = $rootScope.$on(`asset-card-${$scope.asset.id}.update-asset-thumbnail`, () => {
    const forceRefresh = true
    api._setAssetThumbnailSrc(forceRefresh)
  })

  $scope.$on('$destroy', function () {
    deregisterUpdateAssetName()
    deregisterUpdateAssetThumbnail()
  })

  function _getAssetSize (asset) {
    if (asset.size) {
      return Utils.getReadableFileSizeString(asset.size)
    }
  }

  $scope.openShareDialog = (asset) => {
    api.getShareWithGuestsDialogController().then(({ ShareWithGuestsDialogController }) => {
      const shareWithGuestsDialog = UdsModalService.createModal({
        controller: ShareWithGuestsDialogController,
        modalName: 'shareWithGuestsDialog',
        data: {
          itemType: 'assetPack',
          assetPack: [{
            id: asset.id,
            type: 'asset'
          }],
          packTitle: asset.name
        }
      })
      shareWithGuestsDialog.open()
    })
  }

  $scope.handleAssetSelection = (event, selectedAssets, asset) => {
    const isSingleAttach = RepositoryService.isSingleAttach($scope.singleAttach, selectedAssets, asset)

    if (isSingleAttach) {
      return
    }

    if (!$scope.showShareButton && $scope.selectedFolders?.length) {
      $scope.selectedFolders.length = 0
    }

    event.stopPropagation()

    const isShiftPressed = event && event.shiftKey

    if (isShiftPressed) {
      api._handleShiftClickOnAsset(selectedAssets, asset)
    } else {
      if (selectedAssets.length === 0) {
        asset.firstSelection = true
      }

      Utils.toggleItemOnArray(selectedAssets, asset, (a, b) => a.id === b.id)
    }

    $scope.$emit('asset-card.update-selected-assets', selectedAssets)
  }

  $scope.isAssetSelected = (selectedAssets, asset) => {
    selectedAssets = selectedAssets || []
    const foundAsset = selectedAssets.find(selectedAsset => selectedAsset?.id === asset.id)

    return Boolean(foundAsset)
  }

  $scope.handleOpenPreview = event => {
    if (event?.target?.id === 'asset-card-dropdown-icon-btn') {
      return
    }

    if ($scope.asset.extension === 'deskfy') {
      api._openDocPreview()
      return
    }

    $scope.openPreview()
  }

  function _openDocPreview () {
    $state.go('documents.editor', { id: $scope.asset.id, goBackRoute: $scope.goBackRoute, readOnly: 'true' })
  }

  $scope.handleOpenEditor = () => {
    SegmentService.track('doc-edit', { doc_id: $scope.asset.id, page: 'files' })
    $state.go('documents.editor', { id: $scope.asset.id, goBackRoute: $scope.goBackRoute })
  }

  $scope.copyAssetLink = event => {
    event.stopPropagation()
    const nameDisplayLength = 32
    const assetNameLink = RepositoryService.defineFullAssetNameToDisplay($scope.asset, nameDisplayLength)

    NewAssetService.copyAssetUrlToClipboard($scope.asset.id)
      .then(() => {
        ToastService.showSuccessToast(
          $translate.instant('repository.toasts.copyLink.success', { itemName: assetNameLink })
        )
      })
      .catch(() => {
        ToastService.showErrorToast($translate.instant('repository.toasts.copyLink.error'))
      })
  }

  $scope.downloadAsset = event => {
    event.stopPropagation()

    const assetId = $scope.asset.id
    AssetService.downloadAsset(assetId).then(() => {
      SegmentService.track('downloaded-file', { asset_id: assetId })
    })
  }

  $scope.openChooseDocFormatToDownloadDialog = (event) => {
    api.getChooseDocFormatToDownloadDialogController().then(({ ChooseDocFormatToDownloadDialogController }) => {
      const chooseDocFormatToDownloadDialog = UdsModalService.createModal({
        controller: ChooseDocFormatToDownloadDialogController,
        modalName: 'chooseDocFormatToDownloadDialog',
        data: {
          assetId: $scope.asset.id,
          assetName: $scope.asset.name
        }
      })
      chooseDocFormatToDownloadDialog.open()
    })
  }

  $scope.restoreAsset = asset => {
    api.getOrganizeAssetDialogController().then(({ OrganizeAssetController }) => {
      const nameDisplayLength = 32
      const assets = [
        {
          id: asset.id,
          assetName: RepositoryService.defineFullAssetNameToDisplay(asset, nameDisplayLength)
        }
      ]

      const organizeAssetDialog = UdsModalService.createModal({
        controller: OrganizeAssetController,
        modalName: 'organizeAssetDialog',
        data: {
          assets,
          isRestoring: true,
          hasOrganizedFeature: $scope.pricing.organized.access
        },
        onClose: ({ hasMoved }) => {
          if (hasMoved) {
            $timeout(() => {
              api._removeAssetFromList($scope.currentSection, asset)
            })
          }
        }
      })

      organizeAssetDialog.open()
    })
  }

  function _openMoveToTrashDialog (asset) {
    api.getMoveToTrashDialogController().then(({ MoveToTrashController }) => {
      const nameDisplayLength = 32
      const assets = [
        {
          id: asset.id,
          assetSize: $scope.assetSize,
          assetName: RepositoryService.defineFullAssetNameToDisplay($scope.asset, nameDisplayLength),
          assetIcon: $scope.assetIcon
        }
      ]

      const moveToTrashDialog = UdsModalService.createModal({
        controller: MoveToTrashController,
        modalName: 'moveToTrashDialog',
        data: {
          assets
        },
        onClose: hasMoved => {
          if (hasMoved) {
            api._removeAssetFromList($scope.currentSection, asset)
          }
        }
      })

      moveToTrashDialog.open()
    })
  }

  $scope.openSettings = function (tabToOpen) {
    getManageAssetsDialogController().then(({ ManageAssetsDialogController }) => {
      const manageAssetsDialog = UdsModalService.createModal({
        controller: ManageAssetsDialogController,
        modalName: 'manageAssetsDialog',
        data: {
          assets: [$scope.asset],
          tabToOpen
        },
        onClose: updatedAsset => {
          if (!updatedAsset) {
            return
          }

          $scope.asset.name = updatedAsset?.name
          api._handleAssetData()
        }
      })

      manageAssetsDialog.open()
    })
  }

  $scope.organizeAsset = asset => {
    if (!$scope.pricing.organized.access) {
      return api._openPricingUpgradeDialog(
        $translate.instant('repository.sidebarSections.organized'),
        'REPOSITORY.ORGANIZED'
      )
    }

    const nameDisplayLength = 32
    const assets = [
      {
        id: asset.id,
        assetName: Utils.truncateText(asset.name, nameDisplayLength),
        folderId: asset.folderId,
        isFolder: false,
        isOrganized: Boolean(asset.isOrganized || asset.folderId),
        currentPage: $scope.currentPage
      }
    ]

    api.getOrganizeAssetDialogController().then(({ OrganizeAssetController }) => {
      const organizeAssetDialog = UdsModalService.createModal({
        controller: OrganizeAssetController,
        modalName: 'organizeAssetDialog',
        data: {
          assets,
          isRestoring: false,
          hasOrganizedFeature: $scope.pricing.organized.access
        },
        onClose: ({ hasMoved, targetFolderId }) => {
          if (hasMoved) {
            asset.folderId = targetFolderId || null
            asset.isOrganized = true

            if ($state.current.name.includes('organized')) {
              api._removeAssetFromList($scope.currentSection, asset)
            }
          }
        }
      })

      organizeAssetDialog.open()
    })
  }

  function _removeAssetFromList (currentSection, asset) {
    const assetIndex = currentSection.assets.findIndex(sectionAsset => sectionAsset.id === asset.id)

    currentSection.assets.splice(assetIndex, 1)
    currentSection.totalCount--
  }

  $scope.moveAssetToTrash = asset => {
    api._openMoveToTrashDialog(asset)
  }

  function _openPricingUpgradeDialog (featureName, featureSlug) {
    $rootScope.getCompanyWithBillingPackage().then(companyBillingPackage => {
      const isLegacy = Boolean(companyBillingPackage?.billingPackage?.plan?.pricingPackage?.legacy)

      if (!isLegacy) {
        return api.getUpgradeCompanyPlanDialogController().then(({ UpgradeCompanyPlanDialogController }) => {
          const modal = UdsModalService.createModal({
            controller: UpgradeCompanyPlanDialogController,
            modalName: 'upgradeCompanyPlanDialog',
            data: {
              featureName,
              featureSlug
            }
          })

          modal.open()
        })
      }

      return api.getModulesPricingDialogController().then(({ ModulesPricingDialogController }) => {
        const modal = UdsModalService.createModal({
          controller: ModulesPricingDialogController,
          modalName: 'modulesPricingDialog',
          data: {
            module: {
              icon: 'files'
            }
          }
        })

        modal.open()
      })
    })
  }

  $scope.openRemoveAttachmentDialog = function () {
    getRemoveAttachmentDialogController().then(({ RemoveAttachmentController }) => {
      const removeAttachmentDialog = UdsModalService.createModal({
        controller: RemoveAttachmentController,
        modalName: 'removeAttachmentDialog',
        data: {
          currentModule: 'campaign',
          assetId: $scope.asset.id,
          campaignId: $scope.asset.campaignId
        },
        onClose: (removeDetails) => {
          if (removeDetails) {
            api._removeAttachmentFromCampaign(removeDetails, $scope.asset.campaignId)
          }
        }
      })

      removeAttachmentDialog.open()
    })
  }

  function _removeAttachmentFromCampaign (assetId, campaignId) {
    CampaignService.removeAttachmentFromCampaign({ assetId, campaignId })
      .then(() => {
        $rootScope.$emit('campaign.reload-assets')
        ToastService.defaultSuccessToast()
      })
      .catch(() => {
        ToastService.defaultErrorToast()
      })
  }

  $scope.permanentlyDeleteAsset = () => {
    console.log('permanentlyDeleteAsset')
  }

  function _handleShiftClickOnAsset (selectedAssets, clickedAsset) {
    document.getSelection().removeAllRanges()

    api._unselectAllExceptFirstSelected(selectedAssets)

    const firstSelectedAsset = selectedAssets.find(asset => asset.firstSelection)

    if (!firstSelectedAsset) {
      clickedAsset.firstSelection = true
      selectedAssets.push(clickedAsset)
      return
    }

    const currentSectionAssets = $scope.currentSection?.assets || []

    const indexOfClickedAsset = currentSectionAssets.findIndex(asset => asset.id === clickedAsset.id)
    const indexOfFirstSelectedAsset = currentSectionAssets.findIndex(asset => asset.id === firstSelectedAsset.id)

    if (indexOfClickedAsset === -1 || indexOfFirstSelectedAsset === -1) {
      Utils.toggleItemOnArray(selectedAssets, clickedAsset, (a, b) => a.id === b.id)
      return
    }

    const startIndex = Math.min(indexOfFirstSelectedAsset, indexOfClickedAsset)
    const endIndex = Math.max(indexOfFirstSelectedAsset, indexOfClickedAsset) + 1
    const assetsToSelect = currentSectionAssets.slice(startIndex, endIndex)

    selectedAssets.length = 0
    assetsToSelect.forEach(asset => {
      selectedAssets.push(asset)
    })

    if (firstSelectedAsset) {
      const matchingAsset = selectedAssets.find(asset => asset.id === firstSelectedAsset.id)
      if (matchingAsset) {
        matchingAsset.firstSelection = true
      }
    }
  }

  function _unselectAllExceptFirstSelected (selectedAssets) {
    const firstSelectedAsset = selectedAssets.find(asset => asset.firstSelection)

    if (!firstSelectedAsset) {
      return
    }

    selectedAssets.forEach(asset => {
      asset.firstSelection = false
    })

    selectedAssets.length = 0
    firstSelectedAsset.firstSelection = true
    selectedAssets.push(firstSelectedAsset)
  }

  function _setupKeyboardNavigation () {
    $timeout(() => {
      const element = document.querySelector(`[data-id="${$scope.asset.id}"]`)

      if (!element) return

      element.setAttribute('tabindex', '0')

      const handleKeyDown = (event) => {
        if (document.activeElement !== element) return

        const key = event.key
        if (!['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(key)) return

        event.preventDefault()

        const isShiftPressed = event.shiftKey
        const currentSectionAssets = $scope.currentSection?.assets || []
        const currentIndex = currentSectionAssets.findIndex(a => a.id === $scope.asset.id)

        if (currentIndex === -1) return

        let nextIndex = currentIndex
        const assetsPerRow = $scope.visualization === 'grid' ? 4 : 1

        switch (key) {
          case 'ArrowLeft':
            nextIndex = Math.max(0, currentIndex - 1)
            break
          case 'ArrowRight':
            nextIndex = Math.min(currentSectionAssets.length - 1, currentIndex + 1)
            break
          case 'ArrowUp':
            nextIndex = Math.max(0, currentIndex - assetsPerRow)
            break
          case 'ArrowDown':
            nextIndex = Math.min(currentSectionAssets.length - 1, currentIndex + assetsPerRow)
            break
        }

        if (nextIndex === currentIndex) return

        const nextAsset = currentSectionAssets[nextIndex]
        const nextElement = document.querySelector(`[data-id="${nextAsset.id}"]`)

        if (!nextElement) return

        nextElement.focus()

        if (isShiftPressed) {
          api._handleShiftClickOnAsset($scope.selectedAssets, nextAsset)
          $scope.$emit('asset-card.update-selected-assets', $scope.selectedAssets)
          $scope.$apply()
        }
      }

      element.addEventListener('keydown', handleKeyDown)

      $scope.$on('$destroy', () => {
        element.removeEventListener('keydown', handleKeyDown)
      })
    })
  }
}

export { AssetCardController }
